import { render, staticRenderFns } from "./FormTypeOfPaymentReceipt.vue?vue&type=template&id=72260022"
import script from "./FormTypeOfPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./FormTypeOfPaymentReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports